import placeholderImg from "../../images/carrierIcons/placeholder_square.png";
import carrierImg100 from "../../images/carrierIcons/100_square.png";
import carrierImg108 from "../../images/carrierIcons/108_square.png";
import carrierImg109 from "../../images/carrierIcons/109_square.png";
import carrierImg121 from "../../images/carrierIcons/121_square.png";
import carrierImg317 from "../../images/carrierIcons/317_square.png";
import carrierImg2050 from "../../images/carrierIcons/2050_square.png";
import carrierImg3628 from "../../images/carrierIcons/3628_square.png";
import carrierImg208 from "../../images/carrierIcons/208_square.png";
import carrierImg291 from "../../images/carrierIcons/291_square.png";
import carrierImg220 from "../../images/carrierIcons/220_square.png";
import carrierImg206 from "../../images/carrierIcons/206_square.png";
import carrierImg264 from "../../images/carrierIcons/264_square.png";
import carrierImg3577 from "../../images/carrierIcons/3577_square.png";
import carrierImg1900 from "../../images/carrierIcons/1900_square.png";

const getCarrierIconData = (carrierId) => {
  switch (carrierId) {
    case 100:
      return carrierImg100;
    case 108:
      return carrierImg108;
    case 109:
      return carrierImg109;
    case 121:
      return carrierImg121;
    case 317:
      return carrierImg317;
    case 2050:
      return carrierImg2050;
    case 3628:
      return carrierImg3628;
    case 208:
      return carrierImg208;
    case 291:
      return carrierImg291;
    case 220:
      return carrierImg220;
    case 206:
      return carrierImg206;
    case 264:
      return carrierImg264;
    case 3577:
      return carrierImg3577;
    case 1900:
      return carrierImg1900;
    default:
      return placeholderImg;
  }
}

export default function CarrierSquareIcon({ carrierId, className }) {
  const src = getCarrierIconData(carrierId);

  return src ? (
    <img alt="Carrier logo" src={src} className={className} />
  ) : null;
}
